import React from 'react'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'
import { ICON_TYPES } from '../Icon.v2/index'

/**
 * The play video CTA component
 * @param {Map} props.share - The share data
 * @param {Function} props.onClick - The play button click handler
 * @returns {JSX.Element} CTA component
 */
function SharePageVideoPlayCTA (props) {
  const {
    share,
    onClick,
  } = props

  const imageNoText = share.getIn(['content', 'imageNoText'])

  return (
    <div className="share-page__video-play">
      <div
        className="share-page__video-poster"
        style={imageNoText ? { backgroundImage: `url(${imageNoText}}` } : null}
      >
        <div className="share-page__video-overlay">
          <Button
            className="share-page__video-overlay-control"
            type={BUTTON_TYPES.ICON}
            onClick={onClick}
            icon={ICON_TYPES.PLAY}
          />
        </div>
      </div>
    </div>
  )
}

export default SharePageVideoPlayCTA
